// Redirect to new product page
if (product.handle === "natural-shilajit") {
    window.location.href = "/products/natural-rems-shilajit";
}


/************
 Sticky ATC
 ************/
let stickyATCObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        const atcWrapper = document.querySelector("#productATCWrapper");

        if (entry.isIntersecting) {
            document.querySelector("#productATCWrapper").classList.remove("sticky");
        } else {
            document.querySelector("#productATCWrapper").classList.add("sticky");
        }
    });
}, {
    threshold: 0.1,
});

stickyATCObserver.observe(document.querySelector("#product"));

/************
 Product Swiper
 ************/

// setup product swiper
const productSwiper = new Swiper(document.querySelector(".productVisualSwiper"), {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    on: {
        slideChange: function () {
            // update the thumbnail active class
            document.querySelector(".productVisualThumbsSlide.active")?.classList.remove("active");
            document.querySelectorAll(".productVisualThumbsSlide")[this.realIndex]?.classList.add("active");

            // pause all videos
            document.querySelectorAll(".productVisualSwiperSlide video").forEach(element => {
                element.pause();
            });
        }
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});

// play video on slide play click
document.querySelectorAll(".productVisualSwiperSlide").forEach(element => {
    element.addEventListener("click", function () {
        // get video
        const video = this.closest(".productVisualSwiperSlide").querySelector("video");

        // remove play button if it hasn't already been removed
        this.querySelector(".productVisualSwiperSlidePlay")?.remove();

        // show controls
        video.controls = true;

        // play video
        video.play();
    });
});

// change slide on thumbnail click
document.querySelectorAll(".productVisualThumbsSlide").forEach(element => {
    element.addEventListener("click", function () {
        // change slide
        productSwiper.slideTo(this.dataset.index - 1);
    });
});

/**************
 Product Variables
 ***************/

// A PDP may have multiple products, like a variety pack
let products = [
    product,
];


// Check if there is a variety pack and add it to the products array
if (typeof varietyPack !== "undefined") {
    products.push(varietyPack);
}

// set the active product to the first product
let activeProduct = products[0];

// Initialize active selling plan
let activeSellingPlan = null;

/**************
 Product Variants
 ***************/

// update active variant on input changes
document.querySelectorAll("#product input:not([name='sellingPlan'])").forEach(function (element) {
    element.addEventListener("change", function () {
        updateProduct();
    });
});

// update selling plan on input changes
document.querySelectorAll(".productSellingPlan input").forEach(function (element) {
    element.addEventListener("change", function () {
        // set active selling plan
        activeSellingPlan = activeVariant.selling_plan_allocations.find(sellingPlan => {
            return sellingPlan.selling_plan_id === parseInt(document.querySelector(".productSellingPlan.active input:checked")?.value);
        });

        // update price
        updatePrice(activeVariant, activeSellingPlan);
    });
});

function updateSellingPlan() {
    if (activeVariant.selling_plan_allocations.length === 0) {
        return;
    }

    // Find active selling plan
    const activeSellingPlanID = activeVariant.selling_plan_allocations[0].selling_plan_group_id;
    const activeSellingPlanEl = document.querySelector(`.productSellingPlan[id="${activeSellingPlanID}"]`);

    // Hide all selling plans
    document.querySelectorAll(".productSellingPlan").forEach(element => {
        element.classList.remove("active");
    });

    // Uncheck all inactive selling plans
    document.querySelectorAll(`.productSellingPlan:not([id="${activeSellingPlanID}"]) input`).forEach(element => {
        element.checked = false;
    });

    if (!activeSellingPlanEl) {
        return;
    }

    // Show selling plan
    activeSellingPlanEl.classList.add("active");

    // Update selling plan price
    activeSellingPlanEl.querySelector(".productSellingPlanLabelPriceReal").textContent = price(activeVariant.selling_plan_allocations[0].per_delivery_price);

    // Update compare price if available
    activeSellingPlanEl.querySelector(".productSellingPlanLabelPriceCompare").textContent = price(activeVariant.selling_plan_allocations[0].compare_at_price);
}

function updatePrice(variant, sellingPlan = false) {
    const realPrice = document.querySelector("#productPriceReal");
    const comparePrice = document.querySelector("#productPriceCompare");
    const savings = document.querySelector("#productPriceSavings");

    // update price based on selling plan
    if (sellingPlan) {
        realPrice.textContent = price(sellingPlan.per_delivery_price);
        comparePrice.textContent = price(sellingPlan.compare_at_price);
        savings.textContent = `Save ${price(sellingPlan.compare_at_price - sellingPlan.per_delivery_price)}`;
        return;
    }

    // update price
    realPrice.textContent = price(variant.price);
    realPrice.classList.toggle("sale", variant.compare_at_price > variant.price);

    if (variant.compare_at_price > variant.price) {
        comparePrice.textContent = price(variant.compare_at_price);
        savings.textContent = `Save ${price(variant.compare_at_price - variant.price)}`;
    } else {
        comparePrice.textContent = "";
        savings.textContent = "";
    }
}

function updateStock(variant) {
    if (variant.available) {
        // Update indicator to in stock
        document.querySelector("#productStockIndicator").classList.remove("outOfStock");
        document.querySelector("#productStockIndicator").classList.add("inStock");
    } else {
        // Update indicator to out of stock
        document.querySelector("#productStockIndicator").classList.remove("inStock");
        document.querySelector("#productStockIndicator").classList.add("outOfStock");
    }

    // Update ATC button
    document.querySelector("#productATC").disabled = !variant.available;
    document.querySelector("#productATC").textContent = variant.available ? "Add To Cart" : "Sold Out";
}


// update active variant
function updateProduct() {
    // collect options from inputs
    let options = [];
    document.querySelectorAll(`.productOptionPanel.active .productOptionItem`).forEach(group => {
        options.push(group.querySelector(`input:checked`)?.value);
    });

    // find new product based on the options
    activeProduct = products.find(product => {
        return product.variants.find((variant) => {
            return JSON.stringify(variant.options) === JSON.stringify(options)
        })
    });

  console.log(activeProduct);

    // find new variant based on the options
    activeVariant = activeProduct.variants.find((variant) => {
        return JSON.stringify(variant.options) === JSON.stringify(options)
    });

    // check if variant wasn't found
    if (activeVariant === null || activeVariant === undefined) {
        document.querySelector("#productATC").disabled = true;
        document.querySelector("#productATC").textContent = "Not Available";
        return;
    }

    // slide to variant image if it exists
    if (document.querySelector(`[id="${activeVariant?.featured_image.id}"]`)) {
        const slideIndex = parseInt(document.querySelector(`[id="${activeVariant.featured_image.id}"]`).dataset.swiperSlideIndex);
        productSwiper.slideTo(slideIndex);
    }
    // Swap the variant image
    else if (activeVariant.featured_image.src) {
        // update first thumbnail
        document.querySelector('.productVisualSwiperSlideImage').src = activeVariant.featured_image.src;

        // update first slide
        document.querySelector('.productVisualThumbsSlideImage').src = activeVariant.featured_image.src;
    }

    // find options for variant
    const productOptions = document.querySelector(`.productOptions[id="productOptions-${activeProduct.id}"]`);

    if (productOptions) {
        // Show options
        productOptions.classList.add("active");
    }

    // update selling plan
    updateSellingPlan();

    const activeSellingPlanEl = document.querySelector(".productSellingPlan.active");

    // select active selling plan
    if (activeSellingPlanEl) {
        if (activeSellingPlanEl.querySelector("input").checked === false) {
            activeSellingPlanEl.querySelector("label").click();
        }
    }

    // update price
    updatePrice(activeVariant, activeSellingPlan);

    // check if the variant is in stock
    updateStock(activeVariant);
}

// Call updateProduct on page load
updateProduct();

/****************
 * Product Quantity
 */

let quantity = 1;

/**************
 Product ATC
 ***************/

document.querySelector("#main--product-form").addEventListener("submit", async function (e) {
    // add loading animation

  e.preventDefault();


   const quantityFromForm = this.querySelector("input[name='quantity']");

  if(quantityFromForm) {
    quantity = quantityFromForm.value
  }

  const submitButton = document.querySelector("#productATC");
  
    submitButton.classList.add("loading");


    let formData = {
        items: [{
            quantity: quantity,
            id: activeVariant.id,
        }]
    };

    // Selling Plan
    if (activeSellingPlan) {
        formData.items[0].selling_plan = activeSellingPlan.selling_plan_id;
    }

    // add product
    await addProduct(formData);

    // klaviyo tracking
    try {
        _learnq.push(['track', 'Added to Cart', item]);
    } catch (error) {
        console.error("Klaviyo tracking not found");
    }

    // remove loading animation
    submitButton.classList.remove("loading");

    // open cart
    await openCart();

});